export default function ContactTable() {
  return (
    <div className="col-md-9 col-lg-10">
      <div className="coctacts-table">
        <div className="table-responsive custom-scroll-right-bottum">
          <table className="table table-condensed ">
            <thead className="t-head-th-bg">
              <tr>
                <th className="t-head-fixed">
                  <input type="checkbox" value="check" />
                </th>
                <th className="t-head-fixed"> </th>
                <th className="t-head-fixed">Name</th>
                <th className="t-head-fixed">Qualifies</th>
                <th className="t-head-fixed">Contact owner</th>
                <th className="t-head-fixed">Phone No</th>
                <th className="t-head-fixed">Email</th>
                <th className="t-head-fixed">Reason did not qualify</th>
                <th className="t-head-fixed">Preferred intake</th>
                <th className="t-head-fixed">Intake year</th>
                <th className="t-head-fixed">Profile</th>
                <th className="t-head-fixed">City</th>
                <th className="t-head-fixed">Country</th>
              </tr>
            </thead>
            <tbody className="table-bordered">
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" value="check" />
                </td>
                <td className="deal-td">
                  {" "}
                  <span className="deal-count-bg se-yellow badge">
                    {" "}
                    <i className="fas fa-handshake"></i> <b>23</b>{" "}
                  </span>{" "}
                  <span className="deal-count-bg se-orange badge">
                    {" "}
                    <i className="fas fa-file-alt"></i> <b>23</b>{" "}
                  </span>{" "}
                </td>
                <td>
                  <a href="contact-details.html"> Kalpit</a>
                </td>
                <td>Yes</td>
                <td>Sed Sale India</td>
                <td>+919818238099</td>
                <td>Kalpit@gmial.com</td>
                <td>Lorem apsum</td>
                <td>Nov 2020</td>
                <td>2020</td>
                <td>week</td>
                <td>Delhi</td>
                <td>India</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="table-page-details">
          <div className="row">
            <div className="col-md-9">
              <div className="page-number">
                <ul className="pagination justify-content-center">
                  <li className="page-item">
                    <a className="page-link" href="#" >
                      Previous
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link" href="#">
                      Next
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 text-center">
              <div className="page-counter">
                <label>
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>{" "}
                  of <span>70</span> records
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
